<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-building"></i> {{ "TITLE.DELETE-ENTERPRISE" | translate }}</h4>
  </div>
  <div class="modal-body">
    <div>
      <label class="custom-label">
        <i class="fa fa-question-circle text-warning fa-1x"></i>
        {{ "QUESTION.ARE-YOU-SURE-DELETE-RECORD" | translate }}
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success  mw-80" (click)="yes()">
      <i class="fas fa-thumbs-up"></i> {{ "BUTTON.YES" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger mw-80"
            (click)="no()">
      <i class="fas fa-times-circle"></i> {{ "BUTTON.NO" | translate }}</button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
